import React from "react";

import { AssistantChoiceButton, AssistantChoices } from "./styles";
import { IAssistantClarificationChoicesProps } from "./types";

const AssistantClarificationChoices: React.FC<IAssistantClarificationChoicesProps> =
  ({ choices, pending, onChoose }) => (
    <AssistantChoices role="group" aria-label="Choose a task">
      {choices.map((choice) => (
        <AssistantChoiceButton
          key={choice.guideId}
          round
          variant="outlined"
          disabled={pending}
          onClick={() => onChoose(choice.question)}
        >
          {choice.label}
        </AssistantChoiceButton>
      ))}
    </AssistantChoices>
  );

export default AssistantClarificationChoices;
